import billingModule from '../../billing.module';

class BillingProductService {
    constructor($q, billingProductApiService) {
        this.$q = $q;
        this.billingProductApiService = billingProductApiService;
    }

    getProducts() {
        return this.billingProductApiService.getProducts();
    }
}

export default billingModule.service(
    'billingProductService',
    BillingProductService
);



// WEBPACK FOOTER //
// ./modules/billing/services/product/billingProduct.service.js